import { classNames } from "../../helpers/classNames";

/**
 * Book status pills (docs/design/HANDOFF.md, "Status labels").
 *
 * progress  In progress        amber
 * ready     Ready to order     green
 * buy       Ready to buy       green (PDF-only books)
 * cart      In your order      rose
 * ordered   Ordered            warm gray
 * pdf       PDF only           outlined tag, goes next to one of the above
 */
const STATUSES = {
  progress: { label: "In progress", classes: "bg-amber-100 text-amber-800" },
  ready: { label: "Ready to order", classes: "bg-green-100 text-green-800" },
  buy: { label: "Ready to buy", classes: "bg-green-100 text-green-800" },
  cart: { label: "In your order", classes: "bg-md-pink/10 text-md-pink-darker" },
  ordered: { label: "Ordered", classes: "bg-[#EDE8E2] text-[#4A4446]" },
  pdf: { label: "PDF only", classes: "border border-md-control text-[#4A4446] bg-transparent" },
};

export const STATUS_LABELS = Object.fromEntries(Object.entries(STATUSES).map(([k, v]) => [k, v.label]));

const StatusLabel = ({ status, children, className }) => {
  const def = STATUSES[status] || STATUSES.progress;
  return (
    <span
      className={classNames(
        "inline-flex h-6 items-center whitespace-nowrap rounded-full px-2.5 text-xs font-bold leading-none",
        def.classes,
        className
      )}
    >
      {children || def.label}
    </span>
  );
};

export default StatusLabel;
